module.exports = __webpack_public_path__ + "static/media/10.2f68e806.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/10.png
// module id = 692
// module chunks = 0